import { windowOpen } from "echarts/lib/util/format";
export default {
  name: "check-market-terms",
  components: {},
  props: [],
  data() {
    return {
      marketUrl: process.env.VUE_APP_MARKET_BASE_URL
    };
  },
  computed: {},
  mounted() {},
  methods: {
    openNewWindowOfMarket() {
      windowOpen(this.marketUrl, "_blank");
      this.$emit("closeDialog", false);
    }
  }
};
